import { Common, ApiBind } from './common.model';

export class Asset extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'type' })
  type: number;

  @ApiBind({ column: 'image_url' })
  imageURL: string;

  @ApiBind({ column: 'image_data' })
  imageData: string;

  @ApiBind({ column: 'file_name' })
  fileName: string;

  @ApiBind({ column: 'color_code' })
  colorCode: string;

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;

}
